document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector(".range-slider");

    const getElements = () => ({
        progress: slider.querySelector(".progress"),
        minPriceInput: slider.querySelector(".min-price"),
        maxPriceInput: slider.querySelector(".max-price"),
        minInput: slider.querySelector(".min-input"),
        maxInput: slider.querySelector(".max-input"),
    });

    const updateProgress = () => {
        const { progress, minPriceInput, maxPriceInput, minInput, maxInput } = getElements();

        const minValue = parseInt(minInput.value);
        const maxValue = parseInt(maxInput.value);

        const range = maxInput.max - minInput.min;
        const valueRange = maxValue - minValue;
        const width = (valueRange / range) * 100;
        const minOffset = ((minValue - minInput.min) / range) * 100;

        progress.style.width = width + "%";
        progress.style.left = minOffset + "%";

        minPriceInput.value = minValue;
        maxPriceInput.value = maxValue;
    };

    const updateRange = (event) => {
        const { minPriceInput, maxPriceInput, minInput, maxInput } = getElements();
        const input = event.target;

        let min = parseInt(minPriceInput.value);
        let max = parseInt(maxPriceInput.value);

        if (input === minPriceInput && min > max) {
            max = min;
            maxPriceInput.value = max;
        } else if (input === maxPriceInput && max < min) {
            min = max;
            minPriceInput.value = min;
        }

        minInput.value = min;
        maxInput.value = max;

        updateProgress();
    };

    slider.addEventListener("input", (e) => {
        const { minInput, maxInput, minPriceInput, maxPriceInput } = getElements();

        if (e.target.classList.contains("min-price") || e.target.classList.contains("max-price")) {
            updateRange(e);
        } else if (e.target === minInput) {
            if (parseInt(minInput.value) >= parseInt(maxInput.value)) {
                maxInput.value = minInput.value;
            }
            updateProgress();
        } else if (e.target === maxInput) {
            if (parseInt(maxInput.value) <= parseInt(minInput.value)) {
                minInput.value = maxInput.value;
            }
            updateProgress();
        }
    });

    let isDragging = false;
    let startOffsetX;

    slider.addEventListener("mousedown", (e) => {
        const { progress } = getElements();
        if (!e.target.closest(".progress")) return;

        e.preventDefault();
        isDragging = true;
        startOffsetX = e.clientX - progress.getBoundingClientRect().left;
        slider.classList.add("dragging");
    });

    document.addEventListener("mousemove", (e) => {
        if (!isDragging) return;

        const { progress, minInput, maxInput } = getElements();
        const sliderRect = slider.getBoundingClientRect();
        const progressWidth = parseFloat(progress.style.width || 0);

        let newLeft =
            ((e.clientX - sliderRect.left - startOffsetX) / sliderRect.width) * 100;

        newLeft = Math.min(Math.max(newLeft, 0), 100 - progressWidth);

        progress.style.left = newLeft + "%";

        const range = maxInput.max - minInput.min;
        const newMin = Math.round((newLeft / 100) * range) + parseInt(minInput.min);
        const newMax = newMin + parseInt(maxInput.value) - parseInt(minInput.value);

        minInput.value = newMin;
        maxInput.value = newMax;

        updateProgress();
    });

    document.addEventListener("mouseup", () => {
        if (isDragging) {
            isDragging = false;
            slider.classList.remove("dragging");
        }
    });

    updateProgress();
});
